import { render } from "./Wall1View.vue?vue&type=template&id=fe3918fe&scoped=true"
const script = {}

import "./Wall1View.vue?vue&type=style&index=0&id=fe3918fe&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe3918fe"]])

export default __exports__